import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { setLocalTimeZone } from '../../../actions/settings';
import Select from '../../../components/Common/Select';
import { customSelectStyles } from '../../../utilities/helperUtility';

class TimeZoneSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.tzOptions(),
    };
  }

  onTimeZoneChange(timeZone) {
    this.props.setLocalTimeZone(timeZone);
  }

  selectedOption() {
    return this.state.options.find(option => option.value == this.props.localTimeZone);
  }

  tzOptions() {
    return moment.tz.names()
      .reduce((memo, tz) => {
        memo.push({
          name: tz,
          offset: moment.tz(tz).utcOffset()
        });

        return memo;
      }, [])
      .sort((a, b) => {
        return a.offset - b.offset
      })
      .map((tz, index) => {
        const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';
        return { value: tz.name, label: `(GMT${timezone}) ${tz.name}` };
      });
  }

  render() {
    const { styles, className } = this.props;

    return (
      <Select
        useValueAsDefault
        menuPlacement="auto"
        styles={styles}
        className={className}
        name="timezone"
        value={this.props.localTimeZone}
        options={this.state.options}
        onChange={x => this.onTimeZoneChange(x)}
      />
    );
  }
}

export default connect(
  ({ settings }) => ({
    localTimeZone: settings.localTimeZone,
    styles: customSelectStyles(settings.style.select),
  }),
  dispatch => ({
    setLocalTimeZone: (value) => dispatch(setLocalTimeZone(value))
  }),
)(TimeZoneSelect);
